import Navbar from "@layout/Navbar";
import TermlyEmbed from "@common/TermlyEmbed";
import { useEffect } from "react";

export default function TermsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#F8FAFC" }}>
      <Navbar solid />

      <div style={{ paddingTop: 90, background: "#fff", borderBottom: "1px solid #E5E7EB" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "32px 24px 24px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <div style={{ width: 52, height: 52, borderRadius: 14, background: "linear-gradient(135deg,#2563EB,#7C3AED)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 6px 20px rgba(79,70,229,0.3)" }}>
              <i className="fa-solid fa-file-contract" style={{ color: "#fff", fontSize: 22 }} />
            </div>
            <div>
              <h1 style={{ fontSize: "clamp(24px,4vw,36px)", fontWeight: 800, color: "#111827", margin: 0, letterSpacing: "-0.02em" }}>Terms and Conditions</h1>
              <p style={{ fontSize: 14, color: "#9CA3AF", margin: "4px 0 0" }}>FirmConnector.com</p>
            </div>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "32px 24px 80px" }}>
        <div style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 16, padding: "28px 28px", boxShadow: "0 1px 4px rgba(0,0,0,0.04)" }}>
          <TermlyEmbed id="15ea81f9-69f0-4179-83bc-b5563a3d22e9" />
        </div>
      </div>
    </div>
  );
}